<script>
import {Icon} from "ant-design-vue";
import {getImagePath} from "@/i18n";
export default {
  name: "LayoutFooter",
  components: { Icon },
  methods: {
    getImagePath,
    backTop() {
      window.scrollTo(0, 0);
    },
    openWeb(type){
      switch (type){
        case 1:
          window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkyODczODMyNA==&scene=110#wechat_redirect');
          break;
        case 2:
          window.open(`mailto:<${this.$t('footer.email')}>`);
          break;
        case 3:
          window.open('https://www.xiaohongshu.com/user/profile/68202cfc000000000d00a54a?xsec_token=ABauGJNqc0Bs5eHCahI2tO38_slfaRZ2yUFo-h8TaZ4us%3D&xsec_source=pc_search');
          break;
        case 4:
          window.open('https://www.douyin.com/user/MS4wLjABAAAAC_JZ3RMQL7S9-AypUsPQFk_WFBcvreizAD9Q7V9VancOcTzoEdTbm8RhA7YuBbJv?from_tab_name=main');
          break;
      }
    }
  }
}
</script>

<template>
<div class="footer" id="footer" :style="`background-position: ${$route.name === 'home' || $route.name === 'clear' ? 'top center': 'top 264px center'}`">
  <div class="footer-header">
    <div class="back-top" @click="backTop">回到顶部<span><Icon type="arrow-up" /></span></div>
    <div class="footer-img" v-if="$route.name === 'tool'">
      <img :src="getImagePath('tool/tool-footer.svg')" alt="">
    </div>
    <div class="footer-img" v-if="$route.name === 'deeper'">
      <img :src="getImagePath('deeper/deeper-footer.svg')" alt="">
    </div>
  </div>
  <div class="footer-content">
    <div class="footer-item">
      <img src="../assets/images/head-logo.png" alt="">
      <div class="footer-item-text">{{$t('footer.name')}}</div>
      <div class="footer-item-text">{{$t('footer.company')}}</div>
      <div class="footer-item-text">{{$t('footer.post')}}</div>
      <div class="footer-item-text">{{$t('footer.email')}}</div>
      <div class="footer-item-text">{{$t('footer.address')}}</div>
    </div>
    <div class="footer-item right">
      <div class="footer-item-title">{{$t('footer.home')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.home1')}}</div>
      <div class="footer-item-text">{{$t('footer.home2')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.home3')}}</div>
      <div class="footer-item-text">{{$t('footer.home4')}}</div>
      <div class="footer-item-text">{{$t('footer.home5')}}</div>
    </div>
    <div class="footer-item right">
      <div class="footer-item-title">{{$t('footer.qa')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.qa1')}}</div>
      <div class="footer-item-text">{{$t('footer.qa2')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.qa3')}}</div>
      <div class="footer-item-text">{{$t('footer.qa4')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.qa5')}}</div>
      <div class="footer-item-text">{{$t('footer.qa6')}}</div>
    </div>
    <div class="footer-item right">
      <div class="footer-item-title">{{$t('footer.tool')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.tool1')}}</div>
      <div class="footer-item-text">{{$t('footer.tool2')}}</div>
      <div class="footer-item-text" style="margin-bottom: 0">{{$t('footer.tool3')}}</div>
      <div class="footer-item-text">{{$t('footer.tool4')}}</div>
    </div>
    <div class="footer-item right">
      <div class="footer-item-title">{{$t('footer.clear')}}</div>
      <div class="footer-item-text">{{$t('footer.clear1')}}</div>
      <div class="footer-item-text">{{$t('footer.clear2')}}</div>
      <div class="footer-item-text">{{$t('footer.clear3')}}</div>
    </div>
    <div class="footer-item contact">
      <div class="footer-item-title">{{$t('footer.contact')}}</div>
      <img src="@/assets/images/wx.png" draggable="false" alt="" @click="openWeb(1)">
      <img src="@/assets/images/email.png" draggable="false" alt="" style="width: 40px;height: 36px" @click="openWeb(2)">
      <img src="@/assets/images/redbook.png" draggable="false" alt="" @click="openWeb(3)">
      <img src="@/assets/images/tiktok.png" draggable="false" alt="" @click="openWeb(4)">
    </div>
  </div>
  <div class="copyright">
    <span>版权所有 © 杭州深蓝图景数智科技有限公司。保留一切权利。</span>
    <img src="/images/gh.png" alt="gh">
    <span>浙公网安备33042102000890号</span>
    <span>浙ICP备2024133583号-1</span>
  </div>
</div>
</template>

<style scoped lang="less">
.footer{
  width: 1440px;
  margin: 0 auto;
  padding-bottom: 264px;
  background-image: url("../../public/images/footerbg.png");
  background-size: 1440px auto;
  background-repeat: no-repeat;
  background-position: top center;
  //padding: 46px 150px 264px;
  .footer-header{
    width: 100%;
    overflow: hidden;
    .back-top{
      height: 24px;
      margin: 46px auto 102px;
      cursor: pointer;
      font-size: 16px;
      padding: 10px;
      color: #fff;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      span{
        height: 24px;
        line-height: 24px;
      }
    }
    .footer-img{
      height: 180px;
      margin-bottom: 84px;
    }
  }
  .footer-content{
    display: flex;
    justify-content: space-between;
    padding: 0 150px;
    .footer-item{
      &.right{
        .footer-item-title{
          font-weight: bold;
        }
        .footer-item-text{
          text-align: right;
          font-size: 15px;
        }
      }
      img{
        display: block;
        width: 168px;
        margin-bottom: 64px;
      }
      .footer-item-text{
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: left;
        margin-bottom: 10px;
      }
      .footer-item-title{
        font-weight: bold;
        font-size: 16px;
        color: #fff;
        line-height: 22px;
        margin-bottom: 26px;
        text-align: right;
      }
      &.contact{
        img{
          width: 28px;
          margin: 0 auto 24px;
          cursor: pointer;
        }
      }
    }
  }
}
.copyright{
  width: 100%;
  margin-top: 132px;
  font-size: 10px;
  line-height: 20px;
  color: #fff;
  text-align: left;
  padding: 0 150px;
  img{
    width: 13px;
    height: 13px;
    margin-right: 4px;
  }
  span{
    margin-right: 20px;
  }
}
</style>
